// Passthrough for the iOS shortcut deep link (#/add?url=…&auto=1). Users never
// land here themselves — the dashboard inline form handles manual adds. This
// page renders nothing: it creates the property immediately and routes
// straight to the property view (first thing seen is the property loading).
import { createFromInput } from '../lib/create.js';
import { renderHeaderIdentity, STATUSES } from './parts.js';

export function renderAdd(el, { user, query, navigate }) {
  const prefill = query.url || query.text || query.title || '';
  // Optional status from the extension's combo add (#/add?url=…&auto=1&status=…).
  // Invalid values are dropped — the create proceeds with the default.
  const status = STATUSES.includes(query.status) ? query.status : null;

  el.innerHTML = `
    <div class="app-header">
      <a class="brand" href="#/map">Property Source</a>
      <nav><a href="#/map">Map</a></nav>
      <div id="header-who"></div>
    </div>
    <main>
      <div class="card"><div class="muted">Adding property…</div></div>
    </main>`;
  renderHeaderIdentity(el.querySelector('#header-who'), { user, navigate });

  if (!prefill) {
    navigate('#/dashboard');
    return;
  }

  createFromInput(user, prefill, { status })
    .then((res) => navigate(res.dup ? `#/map?pid=${res.dup.id}` : `#/map?pid=${res.pid}`))
    .catch((e) => {
      console.warn('shortcut create failed', e);
      navigate('#/dashboard');
    });
}
